import { render, staticRenderFns } from "./resolution-picker.vue?vue&type=template&id=4f289f3e&scoped=true&"
import script from "./resolution-picker.vue?vue&type=script&lang=js&"
export * from "./resolution-picker.vue?vue&type=script&lang=js&"
import style0 from "./resolution-picker.vue?vue&type=style&index=0&id=4f289f3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f289f3e",
  null
  
)

export default component.exports